export default __webpack_public_path__ + "static/media/placeholder_store01-jp-web.a9ac4de0.png";